
import React from 'react';
import { FormField, FormItem, FormLabel, FormControl, FormMessage } from '@/components/ui/form';
import { Input } from '@/components/ui/input';
import { CardFormValues } from './CardPaymentForm';
import { UseFormReturn } from 'react-hook-form';

interface CardFormFieldsProps {
  form: UseFormReturn<CardFormValues>;
}

const CardFormFields: React.FC<CardFormFieldsProps> = ({ form }) => {
  // Format card number with spaces (4 digits - space)
  const formatCardNumber = (value: string): string => {
    const digits = value.replace(/\D/g, '').slice(0, 16);
    const parts = [];
    
    for (let i = 0; i < digits.length; i += 4) {
      parts.push(digits.slice(i, i + 4));
    }
    
    return parts.join(' ');
  };

  return (
    <>
      <FormField
        control={form.control}
        name="cardNumber"
        render={({ field }) => (
          <FormItem>
            <FormLabel>Card Number</FormLabel>
            <FormControl>
              <Input
                placeholder="1234 5678 9012 3456"
                {...field}
                value={formatCardNumber(field.value)}
                onChange={(e) => {
                  // Store the raw digits without spaces in the form state
                  const rawValue = e.target.value.replace(/\D/g, '').slice(0, 16);
                  field.onChange(rawValue);
                }}
              />
            </FormControl>
            <FormMessage />
          </FormItem>
        )}
      />
      <FormField
        control={form.control}
        name="cardholderName"
        render={({ field }) => (
          <FormItem>
            <FormLabel>Cardholder Name</FormLabel>
            <FormControl>
              <Input placeholder="John Doe" {...field} />
            </FormControl>
            <FormMessage />
          </FormItem>
        )}
      />
      <div className="grid grid-cols-2 gap-3">
        <FormField
          control={form.control}
          name="expiryDate"
          render={({ field }) => (
            <FormItem>
              <FormLabel>Expiry Date</FormLabel>
              <FormControl>
                <Input
                  placeholder="MM/YY"
                  {...field}
                  onChange={(e) => {
                    let value = e.target.value.replace(/[^\d\/]/g, '');
                    if (value.length > 0 && !value.includes('/') && value.length > 2) {
                      value = value.slice(0, 2) + '/' + value.slice(2, 4);
                    }
                    field.onChange(value);
                  }}
                />
              </FormControl>
              <FormMessage />
            </FormItem>
          )}
        />
        <FormField
          control={form.control}
          name="cvv"
          render={({ field }) => (
            <FormItem>
              <FormLabel>CVV</FormLabel>
              <FormControl>
                <Input
                  type="password"
                  placeholder="123"
                  {...field}
                  onChange={(e) => {
                    const value = e.target.value.replace(/\D/g, '').slice(0, 4);
                    field.onChange(value);
                  }}
                />
              </FormControl>
              <FormMessage />
            </FormItem>
          )}
        />
      </div>
    </>
  );
};

export default CardFormFields;
